export default "__VITE_ASSET__C6ktg2p6__"